import { useState, useEffect } from 'react'
import { Layout, Drawer } from 'antd'
import { Sidebar } from '@/components/sidebar/Sidebar'
import { ChatContainer } from '@/components/chat/ChatContainer'
import { useUIStore } from '@/store/uiStore'
import styles from './MainLayout.module.css'

const { Sider, Content } = Layout

const MOBILE_BREAKPOINT = 768
const SIDEBAR_WIDTH = 280

export function MainLayout() {
  const { sidebarCollapsed, setSidebarCollapsed } = useUIStore()
  const [isMobile, setIsMobile] = useState(false)

  // Detect mobile/desktop based on window width
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT
      setIsMobile(mobile)

      // Auto-collapse sidebar on mobile
      if (mobile && !sidebarCollapsed) {
        setSidebarCollapsed(true)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [sidebarCollapsed, setSidebarCollapsed])

  // Close drawer when clicking outside on mobile
  const handleDrawerClose = () => {
    if (isMobile) {
      setSidebarCollapsed(true)
    }
  }

  return (
    <Layout className={styles['layout']}>
      {/* Desktop: Fixed Sider */}
      {!isMobile && (
        <Sider
          width={SIDEBAR_WIDTH}
          collapsed={sidebarCollapsed}
          collapsedWidth={0}
          trigger={null}
          className={styles['sider']}
        >
          <Sidebar />
        </Sider>
      )}

      {/* Mobile: Drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          onClose={handleDrawerClose}
          open={!sidebarCollapsed}
          size={SIDEBAR_WIDTH}
          styles={{ body: { padding: 0 } }}
          className={styles['drawer'] || undefined}
        >
          <Sidebar />
        </Drawer>
      )}

      {/* Main Content */}
      <Layout className={styles['contentLayout']}>
        <Content className={styles['content']}>
          <ChatContainer />
        </Content>
      </Layout>
    </Layout>
  )
}
